import { fmt, texts } from '@/lib/texts';

export function PlaceholderPage({ title, stage }: { title: string; stage: number }) {
  return (
    <div>
      <h1 className="text-2xl font-bold tracking-tight">{title}</h1>
      <p className="mt-2 text-sm text-muted">{fmt(texts.common.stage, { stage })}</p>
    </div>
  );
}
